import { stringToJson, isObj, isString } from '@/utils/tools'
import { storage, developerRegion } from '@/utils/storage'

// 判断是否是IAP
export const isIAP = () => {
  return /iapPay/i.test(window.navigator.userAgent)
}

// 调用IAP的方法
const callIAPPublicFn = (funcName, ...params) => {
  // if (!isIAP()) {
  //   return
  // }
  try {
    if (window.IapJsKit && window.IapJsKit[funcName]) {
      return window.IapJsKit[funcName](...params)
    }
    // eslint-disable-next-line no-empty
  } catch (e) {
    // console.log(e)
  }
}

// 调用postMessage方法
function postMessage(fn) {
  if (!fn) return
  return callIAPPublicFn('postMessage', fn)
}

// 关闭当前webview
export const closeWebview = () => callIAPPublicFn('closeWebView')
// 关闭当前webview 旧方法
export const finishPage = () => postMessage('kachishop://finishPage')

// 新开webview
// type:1 跳转页面有挽留页，比如三方支付页，返回需要刷新收银台页面；
// type:2 跳转页面没有挽留，比如协议页；
// type:3 跳转页面有挽留，比如绑定页，返回不需要刷新收银台页面；
export const openWebview = (type, url) => {
  if (!url.includes('http')) {
    if (!url.includes(window.location.origin)) {
      url = `${window.location.origin}${url}`
    }
  }
  callIAPPublicFn('openWebView', type, url)
}
// valueCallBack
export const valueCallBack = (res) => callIAPPublicFn('valueCallBack', res)

// pageLoadFinish
export const pageLoadFinish = () => callIAPPublicFn('pageLoadFinish')

// userCancel 关闭收银台，取消支付
export const userCancelCashier = () => callIAPPublicFn('userCancel')
// payResult
export const payResultNative = (code, data) =>
  callIAPPublicFn('payResult', code, JSON.stringify(data))
// doPayment
export const doPaymentNative = (orderId) =>
  callIAPPublicFn('doPayment', orderId)

// 获取设备信息
export function getDeviceInfo() {
  const deviceInfo = stringToJson(callIAPPublicFn('deviceInfo') || '{}')
  if (Object.keys(deviceInfo).length > 0 && deviceInfo.packageName) {
    const developer_region = storage.get(developerRegion)
    if (developer_region) {
      deviceInfo.region = developer_region
    }
    return deviceInfo
  } else {
    return {}
  }
}

// 设置收银台是否允许返回键退出, 支付查询过程中不允许退出false；默认true
export const setWebviewCancelable = (flag = true) =>
  callIAPPublicFn('setCancelable', flag)

// 设置js缓存数据
export const setJsSpInfo = (key, value) => {
  if (!isObj(value)) {
    // console.log('非对象！不允许')
    return
  }
  const oldValue = getJsSpInfo(key)
  const newValue = oldValue ? { ...oldValue, ...value } : value
  callIAPPublicFn('setJsSpInfo', key, JSON.stringify(newValue))
}

// 返回缓存的js数据
export const getJsSpInfo = (key) => {
  if (!key) {
    return null
  }
  const infos = callIAPPublicFn('getJsSpInfo', key)
  const allValues = stringToJson(infos)
  return allValues
}

export const setBrowserInfo = (info = {}) =>
  callIAPPublicFn('browserInfo', JSON.stringify(info))


export const saveBindInfo = (data) => callIAPPublicFn('saveBindInfo', isString(data) ? data : JSON.stringify(data))